import Tastet from '../tastet.js';

var STATES = {
  END_OF_LIST: 'end-of-list',
};

export default class More extends Tastet.View {
  // init ------------------------------------------------------------------------------------------------------------
  init($el, data) {
    data = this.set(data || {}, {
      url: 'more-posts',
      name: '',
      query: {},
      page: 1,
      max: 0, // max page
      count: null, // count of items per page
      position: 'append', // how to add the new posts
    });
  }

  addEvents() {
    if (this.$more) {
      this.on(this.$more, 'click', this.more_onClick);
    }
  }

  render() {
    if (this._isEnd()) {
      this.state(STATES.END_OF_LIST, true);
      this.$more.remove();
    }
  }

  // private  --------------------------------------------------------------------------------------------------------
  _isEnd() {
    return this.data.page > 1 && this.data.page >= this.data.max;
  }

  // events ----------------------------------------------------------------------------------------------------------
  more_onClick(e) {
    e.stop();
    this.next();
  }

  // methods ---------------------------------------------------------------------------------------------------------
  next() {
    if (this.isLoading()) return;

    this.isLoading(true);

    var url = this.data.url;
    if (!~url.indexOf('/')) {
      url = (Tastet.settings.ajax_url || '') + '?action=' + url;
    }

    var layout = this.$more.data('card') ? this.$more.data('card') : '';

    var data = {
      name: this.data.name,
      query: this.data.query,
      count: this.data.count === null ? '' : this.data.count,
      page: this.data.page + 1,
      layout: layout,
      region: Tastet.settings.region || '',
    };

    this.$list.load(url, {
      data: data,
      position: this.data.position,
      callback: function (nodes, response, success) {
        this.isLoading(false);

        if (!success) {
          // error
          return;
        }

        this.scan(nodes, { lazy: true });

        this.data.page++;
        this.data.max = response.total_pages || this.data.max;
        this.render();

        this.trigger('fetched-page', {
          page: this.data.page,
          max: this.data.max,
          end: this._isEnd(),
        });
      },
    });
  }
}
